/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import { formatSeconds } from '@dtvgo/date-utils';

/* Utils */
import { ProgressBarContainerClassNames } from './utils';

function CurrentTime({ progress }) {
  return (
    <div className={ProgressBarContainerClassNames.element('current-time')}>
      <span>
        {formatSeconds(progress)}
      </span>
    </div>
  );
}

CurrentTime.propTypes = {
  progress: PropTypes.number,
};

CurrentTime.defaultProps = {
  progress: 0,
};

export default memo(CurrentTime);
